
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store";

// Models
import {AppCoachResourcesDietsListIndex} from "@/models/app/coach/resources/diets/list/index";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AppCoachResourcesDietsListFormCreateIndexVue from "@/views/app/coach/resources/diets/list/form/create.vue";
import AppCoachResourcesDietsListFormUpdateIndexVue from "@/views/app/coach/resources/diets/list/form/update.vue";
import AppCoachResourcesDietsListFormRemoveIndexVue from "@/views/app/coach/resources/diets/list/form/remove.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    AppCoachResourcesDietsListFormCreateIndexVue,
    AppCoachResourcesDietsListFormUpdateIndexVue,
    AppCoachResourcesDietsListFormRemoveIndexVue,
  },
})
export default class AppCoachResourcesDietsListIndexVue extends Vue {
  isLoading: boolean | null = false;

  diets: Array<AppCoachResourcesDietsListIndex> = [];

  async getDiets(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/administration/diets`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.diets = r.data.sort(function (a, b) {
          if (a.content.name < b.content.name) {
            return -1;
          }
          if (a.content.name > b.content.name) {
            return 1;
          }
          return 0;
        });
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getDiets();
  }
}
